import { useQuery } from '@tanstack/react-query';
import { BrandParams } from '../model/types';
import { brandApi } from './client';

export const useBrands = (params: BrandParams, enabled?: boolean) =>
  useQuery({
    queryKey: ['brands', params],
    queryFn: () => brandApi.getAll(params),
    enabled,
  });

export const useBrand = (id?: string, params?: BrandParams) =>
  useQuery({
    queryKey: ['brand', id, params],
    queryFn: () => brandApi.getById(id, params),
    enabled: Boolean(id) && Boolean(params?.lat) && Boolean(params?.long),
  });
